import { createContext, useContext } from 'react'

const defaultIndexResult = {
  hits: [], hitCount: 0, hasMore: false, loadMore: () => {},
}

const defaultValue = {
  // Multi-index autocomplete groups — used by TopNavSearchBar.
  suggestions: [],
  // Flat hits from the primary index — used by single-index consumers (e.g. Add-to-Class modal).
  hits: [],
  // Query string — owned by SearchOrchestrator, not by any provider.
  currentRefinement: '',
  // Updates the query in SearchOrchestrator, which propagates to all providers.
  refine: () => {},
  // Per-index paginated results — used by SearchResultsContainer.
  indexResults: {
    repos: { ...defaultIndexResult },
    folders: { ...defaultIndexResult },
    // eslint-disable-next-line camelcase
    sets_questions: { ...defaultIndexResult },
  },
}

export const SearchContext = createContext(defaultValue)

export function useSearchContext() {
  return useContext(SearchContext)
}
